import moment from "moment";
import axios from "@/axios";

export default {
	computed: {
		userRole() {
			return this.$store.state.auth.role;
		}
	},
	methods: {
		getDatesFromMoment(off, to, format = "YYYY-MM-DD") {
			off = moment(off).format(format);
			to = moment(to).format(format);
			let day = new Date(to);
			let formattedTo = new Date(
				day.getFullYear(),
				day.getMonth(),
				day.getDate() + 1
			);
			formattedTo = moment(formattedTo).format(format);

			return {
				off,
				to: formattedTo
			};
		},

		async dbGetFullMessage(id) {
			const url = `/chat/get-full-text-message/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		// ------------------- Utils
		dbGetOptions(list) {
			let options = "";

			for (let item of list) {
				if (item !== undefined && item !== null && item !== "") {
					options += `&${item}`;
				}
			}

			if (options.length !== 0)
				options = "?" + options.substr(1, options.length - 1);

			return options;
		},
		// ------------------- End Utils
		async dbGetMangers() {
			const url = `/${this.userRole}/manager`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetAuthors() {
			const url = `/${this.userRole}/author`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetWebsites() {
			const url = `/settings/get-website-list`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetClients(options) {
			if (!options) {
				const url = `/${this.userRole}/client/simple`;
				return (await this.$http.get(url)).data.data;
			}
			const url = `/${this.userRole}/client?` + options;
			return (await this.$http.get(url)).data;
		},
		async dbGetClient(id) {
			const url = `/${this.userRole}/client/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		async dbGetClientsList({ tab, name, limit, offset, email, phone, current_manager, unread_messages_count }) {
			let options = "";

			if (tab !== "" && tab !== undefined && tab !== null) {
				options += `&tab=${tab}`;
			}

			if (name !== "" && name !== undefined && name !== null) {
				options += `&filter[name]=${name}`;
			}

			if (limit !== "" && limit !== undefined && limit !== null) {
				options += `&limit=${limit}`;
			}

			if (offset !== "" && offset !== undefined && offset !== null) {
				options += `&offset=${offset}`;
			}

			if (email !== "" && email !== undefined && email !== null) {
				options += `&filter[email]=${email}`;
			}

			if (phone !== "" && phone !== undefined && phone !== null) {
				options += `&filter[phone]=${phone}`;
			}
			if (current_manager !== "" && current_manager !== undefined && current_manager !== null) {
				options += `&filter[current_manager]=${current_manager}`;
			}
			if (unread_messages_count !== "" && unread_messages_count !== undefined && unread_messages_count !== null) {
				options += `&filter[unread_messages_count]=${unread_messages_count}`;
			}

			return await this.dbGetClients(options);
		},
		// ------------------- Users

		// ------------------- End Users

		// ------------------- Task
		async dbCreateTask(date, description, idOrder) {
			let formData = {
				date_time: moment(date).format("YYYY-MM-DD HH:mm:ss"),
				description: description,
				order_id: idOrder
			};

			const url = `/${this.userRole}/task/create/`;
			return (await this.$http.post(url, formData)).data.data;
		},

		async dbCreateTaskToClient(date, description, idClient) {
			let formData = {
				date_time: moment(date).format("YYYY-MM-DD HH:MM:ss"),
				description: description,
				user_client_id: idClient
			};

			const url = `/${this.userRole}/task/create/`;
			return (await this.$http.post(url, formData)).data.data;
		},

		async dbViewTask(taskId) {
			const url = `/${this.userRole}/task/view/${taskId}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbCompleteTask(taskId, isCompleted = true) {
			const url = `/${this.userRole}/task/complete/${taskId}`;
			const data = { is_completed: isCompleted };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbCloseTask(taskId) {
			const url = `/${this.userRole}/task/delete/${taskId}`;
			return (await this.$http.post(url)).data.data;
		},

    async dbGetTaskComments(groupId) {
      const url = `/${this.userRole}/task-group/comments/${groupId}`
			return (await this.$http.get(url)).data.data;
    },

    async dbAddTaskComment({id, comment}) {
      const url = `/${this.userRole}/task-group/add-comment/${id}`
      const body = {
        comment
      }
			return (await this.$http.post(url, body)).data.data;
    },
		// ------------------- End Task

		// ------------------- Tickets
		async dbSetOrderUpdateState(orderId) {
			const url = `/${this.userRole}/order/set-state-update/${orderId}`;

			const body = {
				id: orderId
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbSetOrderViewState(orderId) {
			const url = `/${this.userRole}/order/set-state-view/${orderId}`;

			const body = {
				id: orderId
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbCreateMarginalityTask(orderId) {
			const url = `/${this.userRole}/order/create-marginality-task/${orderId}`;

			const body = {
				id: orderId
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbCreateOrderPriceTask(orderId) {
			const url = `/${this.userRole}/order/create-price-task/${orderId}`;

			const body = {
				id: orderId
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbCheckMarginality(data) {
			let url = `${this.userRole}/order/check-milestone-marginality/${data.id}`;

			const body = {
				price_client: +data.price_client,
				price_junior_middle: +data.price_junior_middle,
				price_senior: +data.price_senior,
				price_native: +data.price_native
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbSetPaymentManually({ id, amount }) {
			let url = `${this.userRole}/order-milestone/set-paid/${id}`;
			const body = {
				amount: +amount
			};
			return (await this.$http.post(url, body)).data.data;
		},

		async dbSendRefund(id, reason, amount) {
			let url = `admin/order/return/${id}`;
			const body = {
				return_reason_id: reason,
				amount
			};
			return (await this.$http.post(url, body)).data.data;
		},

		async dbSetManagerToOrder(orderId, managerId) {
			let url = `/admin/order/set-manager/${orderId}`;
			const body = {
				manager_id: managerId
			};
			return (await this.$http.post(url, body)).data.data;
		},
		async dbSetGeneratorManagerToOrder(orderId, generator_manager_id) {
			let url = `/admin/order/set-generator-manager/${orderId}`;
			const body = {
				generator_manager_id: generator_manager_id
			};
			return (await this.$http.post(url, body)).data.data;
		},
		async dbSetCurrentManagerToOrder(id, managerId) {
			let url = `/manager/order/set-manager/${id}`;
			const body = {
				manager_id: managerId
			};
			return (await this.$http.post(url, body)).data.data;
		},
		async dbSendComment(id, content) {
			const url = `/${this.userRole}/order/create-comment/${id}`;
			const data = {
				content
			};
			return (await this.$http.post(url, data)).data.data;
		},

		async dbCheckMessagesStatus(id) {
			const url = `/${this.userRole}/order/get-chat-statuses/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbDownloadInvoices(off, to) {
			const dates = this.getDatesFromMoment(off, to);

			let params = {
				date_from: dates.off,
				date_to: dates.to
			};
			const url = `/${this.userRole}/order/download-invoices`;
			return (await this.$http.post(url, params)).data.file;
		},

		async dbDownloadActs(off, to) {
			const dates = this.getDatesFromMoment(off, to);

			let params = {
				date_from: dates.off,
				date_to: dates.to
			};
			const url = `/${this.userRole}/payout/download-acts`;
			return (await this.$http.post(url, params)).data.file;
		},

		async dbGetTickets(type, options = "") {
			const url = `/${this.userRole}/order?tab=${type}${options}`;
			return (await this.$http.get(url)).data;
		},

		async dbGetFilteredTickets({
			type,
			off,
			to,
			manager,
			author,
			client,
			work,
			level,
			name,
			cid,
			is_ppg,
			phone,
			id,
			limit,
			offset,
			sortKey,
			sortType,
			website
		}) {
			let options = "";

			if (
				sortType !== null &&
				sortType !== "" &&
				sortType !== undefined
			) {
				options += `&sort[${sortKey}]=${sortType}`;
			}

			if (limit !== "" && limit !== null && limit !== undefined)
				options += `&limit=${limit}`;

			if (offset !== "" && offset !== null && offset !== undefined)
				options += `&offset=${offset}`;

			if (off !== "" && off !== null && off !== undefined)
				options += `&filter[date_from]=${moment(off).format(
					"YYYY-MM-DD"
				)}`;

			if (to !== "" && to !== null && to !== undefined)
				options += `&filter[date_to]=${moment(to).format(
					"YYYY-MM-DD"
				)}`;

			if (manager !== "" && manager !== null && manager !== undefined)
				options += `&filter[manager]=${manager}`;

			if (author !== "" && author !== null && author !== undefined)
				options += `&filter[author]=${author}`;

			if (client !== "" && client !== null && client !== undefined)
				options += `&filter[client]=${client}`;

			if (website !== "" && website !== null && website !== undefined)
				options += `&filter[web_site]=${website}`;

			if (name !== "" && name !== null && name !== undefined)
				options += `&filter[name]=${name}`;

			if (cid !== "" && cid !== null && cid !== undefined)
				options += `&filter[cid]=${cid}`;

			if (phone !== "" && phone !== null && phone !== undefined) {
				options += `&filter[phone]=${phone}`;
			}
			if (is_ppg !== "" && is_ppg !== null && is_ppg !== undefined) {
				options += `&filter[is_ppg]=${is_ppg}`;
			}
			if (id !== "" && id !== null && id !== undefined)
				options += `&filter[id]=${id}`;

			if (work !== "" && work !== null && work !== undefined)
				options += `&filter[work_type]=${work}`;

			if (level !== "" && level !== null && level !== undefined)
				options += `&filter[quality_level]=${level}`;

			return await this.dbGetTickets(type, options);
		},

		async dbGetClientTickets(
			id,
			{ tab, offset, limit, date_from, date_to, name }
		) {
			let options = "";

			if (tab !== undefined) options += `&tab=${tab}`;
			if (offset !== undefined) options += `&offset=${offset}`;
			if (limit !== undefined) options += `&limit=${limit}`;
			if (date_from !== undefined)
				options += `&filter[date_from]=${moment(date_from).format(
					"YYYY-MM-DD"
				)}`;
			if (date_to !== undefined)
				options += `&filter[date_to]=${moment(date_to).format(
					"YYYY-MM-DD"
				)}`;
			if (name !== undefined) options += `&filter[name]=${name}`;

			const url = `/${this.userRole}/client/get-orders?id=${id}${options}`;
			return (await this.$http.get(url)).data;
		},

		async dbSendOrderApproval(id) {
			const url = `/${this.userRole}/order/send-for-approval/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbConfirmOrder(id) {
			const url = `/${this.userRole}/order/confirm/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbGetQualityProblemsList({ offset, limit }) {
			let options = "";
			if (offset !== undefined) options += `&offset=${offset}`;
			if (limit !== undefined) options += `&limit=${limit}`;

			const url = `/${this.userRole}/quality-problems?${options}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbGetQualityProblemsMessages({ id }) {
			const url = `/${this.userRole}/quality-problems/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbSetQualityProblemMessage({id, message}) {
			const url = `/${this.userRole}/quality-problems/${id}/add`;
			const body = {
				message
			};
			return (await this.$http.post(url, body)).data.data;
		},
		// ------------------- End Tickets

		// ------------------- Order
		async dbOrderCheckMarginality({ orderId, authorId }) {
			const url = `/${this.userRole}/order/check-marginality/${orderId}`;

			const body = {
				author_id: authorId
			};

			return (await this.$http.post(url, body)).data;
		},

		async dbViewOrder(id) {
			const url = `${this.userRole}/order/view/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbUpdateOrder(idModel, data) {
			const url = `/${this.userRole}/order/update/${idModel}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetClientNotAnswer(id) {
			const url = `/${this.userRole}/order/set-client-not-answer/${id}`;
			return await this.$http.post(url);
		},

		async dbSetAutoSendFiles(id, isAllow) {
			const url = `/${this.userRole}/order/set-autosend-files/${id}`;
			const data = { is_allow: isAllow };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbGetRecommendedPrice(id) {
			const url = `/${this.userRole}/order/get-recommended-price/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbGetRecommendedPriceForCreating({
			subject,
			workType,
			level,
			pagesAmount,
			dueDate
		}) {
			const url = `/${this.userRole}/order/get-recommended-price-new-order`;
			const options =
				`?subject_id=${subject}` +
				`&work_type_id=${workType}` +
				`&quality_level_id=${level}` +
				`&pages_number=${pagesAmount}` +
				`&due_date=${dueDate}`;

			return (await this.$http.get(url + options)).data.data;
		},

		async dbBackOrderToProcess(id) {
			const url = `/${this.userRole}/order/edit/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbDeleteAuthorFromOrder(id, payload) {
			const url = `/${this.userRole}/order/delete-author/${id}`;
			return (await this.$http.post(url, payload)).data.data;
		},

		async fetchAuthorsByType(type) {
			if (!type) {
				this.authors = [];
				return;
			}

			const url = `/${this.userRole}/author?filter[type]=${type.value}`;
			const response = await this.$http.get(url);

			this.authors = response.data.data.map(a => ({
				...a,
				full_name: `${a.first_name} ${a.last_name}`
			}));
		},

		async dbGetOrderStatusPaid(id) {
			const url = `/${this.userRole}/order/get-status-paid/${id}`;
			return (await this.$http.get(url)).data.data;
		},

    async dbCheckOrderFile(id) {
			const url = `/${this.userRole}/order-milestone/check-file/${id}`;
			return (await this.$http.post(url)).data.data;
    },
		// ------------------- End Order

		// ------------------- Stage
		async dbViewStages(id) {
			const url = `/${this.userRole}/order/get-milestones/${id}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbCreateStage(id, data) {
			const url = `/${this.userRole}/order/create-milestone/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateStage(id, data) {
			const url = `/${this.userRole}/order/update-milestone/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateStagePrice(id, data) {
			const url = `/${this.userRole}/order/update-milestone-price/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdatePaymentPrice(id, price_client) {
			const url = `/admin/order/update-milestone-client-price/${id}`;
			return (await this.$http.post(url, { price_client })).data.data;
		},

		async dbRemoveStage(id) {
			const url = `/${this.userRole}/order/delete-milestone/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbConfirmStagePayout(id) {
			const url = `/${this.userRole}/order/confirm-milestone/${id}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbSetStageDone(id, authorAward, notNotify, closureStatus, comment, orderId, userId) {
			const url = `${this.userRole}/order/complete-with-payment-to-author/${id}`;
			const data = {
				amount: authorAward,
				not_notify_client: notNotify,
				status: closureStatus,
				comment: comment,
				order_id: orderId,
				user_id: userId
      };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetStageFailed(id, reason, notNotify, comment, caused_by, userId) {
			let url = `${this.userRole}/order-milestone/set-failed/${id}`;
			const data = {
				fail_reason_id: reason,
				not_notify_client: notNotify,
				comment,
				caused_by,
				userId
      };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetStageFailedWithPayout(id, reason, amount, notNotify, comment, caused_by, userId) {
			let url = `${this.userRole}/order-milestone/set-failed-with-payout/${id}`;
			const data = {
				fail_reason_id: reason,
				amount,
				not_notify_client: notNotify,
				comment,
				caused_by,
				userId
      };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSendStageFiles(id) {
			const url = `${this.userRole}/order/send-files/${id}`;
			return (await this.$http.post(url)).data.data;
		},
		// ------------------- End Stage

		// ------------------- Author finding
		async dbGetAuthorBalance(id) {
			const url = `/admin/author/get-balance/${id}`;
			return (await this.$http.get(url)).data.data;
		},
		async dbChangeAuthorBalance(id, amount, action) {
			let url;
			if (action === "in") {
				url = `/admin/author/balance-in/${id}`;
			} else {
				url = `/admin/author/balance-out/${id}`;
			}
			const data = {
				amount
			};
			return (await this.$http.post(url, data)).data.data;
		},

		async dbInviteAuthor(orderId, authorId) {
			const url = `/${this.userRole}/order/invite-author/${orderId}`;
			const data = { author_id: authorId };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbSetAuthor(orderId, authorId) {
			const url = `/${this.userRole}/order/set-author/${orderId}`;
			const data = { author_id: authorId };
			return (await this.$http.post(url, data)).data.data;
		},
		async dbSetTicketStatus(orderId, payload) {
			const url = `/${this.userRole}/order/set-status/${orderId}`;
			return (await this.$http.post(url, payload)).data.data;
		},
		async dbSetSystemSettings(payload) {
			const url = `/admin/settings/update`;
			return (await this.$http.post(url, payload)).data.data;
		},
		async dbGetSystemSettings() {
			const url = `/admin/settings`;
			return (await this.$http.get(url)).data.data;
		},

		async dbAddAuthorToFavorite(authorId) {
			const url = `/${this.userRole}/author/add-author-to-favorite/${authorId}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbDeleteAuthorFromFavorite(authorId) {
			const url = `/${this.userRole}/author/delete-author-from-favorite/${authorId}`;
			return (await this.$http.post(url)).data.data;
		},

		async dbGetAuthorInviteList({ name, level, subject }) {
			let options = "";

			if (name !== undefined) options += `&filter[name]=${name}`;
			if (level !== undefined)
				options += `&filter[quality_level]=${level}`;
			if (subject !== undefined) options += `&filter[subject]=${subject}`;

			if (options.length > 0)
				options = "?" + options.substr(1, options.length);

			const url = `/${this.userRole}/author/get-author-list-for-invite${options}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbSetAuthorPenalty(authorId, orderId, reason, amount, message, warning) {
			const url = `admin/author/penalty/${authorId}`;
			const data = {
				order_id: +orderId,
				penalty_reason_id: reason,
				amount,
				message,
				warning
			};
			return (await this.$http.post(url, data)).data.data;
		},

		async dbGetAuthorPenaltyList(id) {
			const url = `${this.userRole}/author/penalty-list/${id}`;
			return (await this.$http.get(url)).data;
		},

    async dbRefreshBankCards() {
      const url = 'author/profile/refresh-cards'
      return (await this.$http.post(url)).data;
    },

    async dbGetActiveOrdersNumber(id) {
      const url = `admin/author/get-active-orders-number/${id}`
      return (await this.$http.get(url)).data.data
    },

    async dbGetActiveOrdersList(id) {
      const url = `admin/author/active-orders-list/${id}`
      return (await this.$http.get(url)).data.data
    },

    async dbGetAuthorsCommentsList(id) {
      const url = `/${this.userRole}/author/${id}/comments`
      return (await this.$http.get(url)).data.data
    },

    async dbSetAuthorsCommentsList(id, message) {
      const url = `/${this.userRole}/author/${id}/comments`
		const body = {
			message
		}
      return (await this.$http.post(url, body)).data.data
    },
		// ------------------- End Author finding

		// ------------------- Files
		async dbUploadMany(files, idChat) {
			if (files.length === 0) return [];
			const url = "/upload/many";
			const params = idChat ? `?chat_id=${idChat}` : "";
			const res = await this.$http.post(
				url + params,
				this.$formData({ files })
			);
			return res.data.data.map(item => ({
				url: item.path,
				fullUrl: item.url
			}));
		},
		async dbDeleteOne(orderId, path) {
			const url = "/upload/delete";
			const data = { order_id: orderId, patch: path };
			const res = await this.$http.post(url, data);
			return res.data.data;
		},
		// ------------------- End Files

		// ------------------- Settings
		async dbGetFailReasons() {
			const res = await this.$http.get(
				"/settings/get-order-fail-reasons"
			);
			return res.data.data;
		},

		async dbGetReturnReasons() {
			const res = await this.$http.get(
				"/settings/get-order-return-reasons"
			);
			return res.data.data;
		},
		async dbGetTags(genre) {
			const { data } = await this.$http.get(`/${this.userRole}/order/get-tag-list`, {
				params: { genre },
			});

			if (data && data.status === 200 && typeof data.data === 'object') {
				return data.data;
			}
			return {};
		},

		async dbAddTagToFile(data) {
			const url = `/${this.userRole}/order/add-tag-to-file`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbGetOrderFileTags(orderFileId) {
			const url = `/${this.userRole}/order/get-order-file-tags?order_file_id=${orderFileId}`;
			return (await this.$http.get(url, orderFileId)).data.data;
		},

		async dbGetReplyTypes() {
			const res = await this.$http.get("/settings/get-reply-types");
			return res.data.data;
		},

		async dbGetPenaltyReasons() {
			const res = await this.$http.get("/settings/get-penalty-reasons");
			return res.data.data;
		},
		async dbGetAuthorPrice(orderId, authorId) {
			const res = await this.$http.get(`/${this.userRole}/order/get-author-prices/${orderId}?author_id=${authorId}`);
			return res.data.data;
		},

		async dbGetFailsReasons() {
			const res = await this.$http.get(
				"/settings/get-order-fail-reasons"
			);
			return res.data.data;
		},
		// ------------------- End Settings

		// ------------------- Websites
		async dbGetWebSites(options) {
			let url = `/${this.userRole}/website`;

			if (options !== undefined) {
				let optionsUrl = "";

				if (options.name !== undefined && options.name !== "")
					optionsUrl += `&filter[site]=${options.name}`;

				if (options.uid !== undefined && options.uid !== "")
					optionsUrl += `&filter[site_uid]=${options.uid}`;

				if (options.email !== undefined && options.email !== "")
					optionsUrl += `&filter[email]=${options.email}`;

				if (
					options.managerPercent !== undefined &&
					options.managerPercent !== ""
				)
					optionsUrl += `&filter[commission_manager_percent]=${options.managerPercent}`;

				if (optionsUrl.length > 0)
					optionsUrl = "?" + optionsUrl.substr(1, optionsUrl.length);

				url += optionsUrl;
			}

			return (await this.$http.get(url)).data.data;
		},

		async dbViewWebsite(id, query) {
			const url = `/${this.userRole}/website/view/${id}`;
			let options = '';

			if (query) {
				options += `&query=${query}`;
      }

      if (options.length !== 0 && url.indexOf('?') === -1) {
        options = '?' + options
      }

			return (await this.$http.get(url + options)).data.data;
		},

		async dbCreateWebsite(data) {
			const url = `/${this.userRole}/website/create`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateWebsite(id, data) {
			const url = `/${this.userRole}/website/update/${id}`;
			return (await this.$http.post(url, data)).data.data;
		},

		async dbDeleteWebsite(id) {
			const url = `/${this.userRole}/website/delete/${id}`;
			return (await this.$http.post(url)).data.data;
		},

    async dbEditWebsiteAnswer(id, message) {
      const url =  `/${this.userRole}/website/update-chat-template-message/${id}`
      const body = {
        message,
      }

			return (await this.$http.post(url, body)).data.data;
    },

		async dbGetManagerProfiles() {
			const url = `/${this.userRole}/profile/websites`;
			return (await this.$http.get(url)).data.data;
		},

		async dbGetManagerProfilesByAdmin(managerId) {
			const url = `/${this.userRole}/manager/websites/${managerId}`;
			return (await this.$http.get(url)).data.data;
		},

		async dbUpdateManagerProfiles(websites) {
			const url = `/${this.userRole}/profile/update-websites`;
			const data = { websites };
			return (await this.$http.post(url, data)).data.data;
		},

		async dbUpdateManagerProfilesByAdmin(managerId, websites) {
			const url = `/${this.userRole}/manager/update-websites/${managerId}`;
			const data = { websites };
			return (await this.$http.post(url, data)).data.data;
		},

    async dbGetTemplateTable({ name }) {
      const url = `/${this.userRole}/chat-reply-template`
			let options = '';

			if (name) {
				options += `&query=${name}`;
      }

      if (options.length !== 0 && url.indexOf("?") === -1) {
        options = "?" + options
      }

      return (await this.$http.get(url + options)).data.data;
    },

    async dbGetChatTemplateMessages({ id, query }) {
      const url = `/chat/get-reply-templates/${id}`
			let options = '';

			if (query) {
				options += `&query=${query}`;
      }

      if (options.length !== 0 && url.indexOf("?") === -1) {
        options = "?" + options
      }

      return (await this.$http.get(url + options)).data.data;
    },
		// ------------------- End Websites

		// ------------------- Stats
		async dbGetGraph(graphicUrl, from, to, selectedManager) {
			const url = `/${this.userRole}${graphicUrl}`;
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;

			if (selectedManager !== undefined && selectedManager !== null) {
				options += `&filter[user_id]=${selectedManager}`;
			}
			if (options.length !== 0 && url.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetPaidOrders(from, to) {
			const url = `/stats/get-orders-paid`;
			return await this.dbGetGraph(url, from, to);
		},

		async dbGetManagersPaidOrders(from, to, managers, sites) {
			const url = `/${this.userRole}/stats/get-table-income-manager`;
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;

			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;

			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			// if (sort !== undefined && sort !== null)
			// 	options += `&filter[sort]=${sort}`;

			if (options.length !== 0 && url.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetManagersGraph(managers, from, to, sites) {
			const url = `/${this.userRole}/stats/get-graph-income-manager`;
			let options = "";

			if (from !== undefined && from !== null) {
				options += `&filter[date_from]=${from}`;
			}

			if (to !== undefined && to !== null) {
				options += `&filter[date_to]=${to}`;
			}

			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1) {
				options = "?" + options.substr(1, options.length - 1);
			}

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetManagersNumberOfPayments(managers, from, to, sites) {
			const url = `/${this.userRole}/stats/get-number-of-payments`;
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;
			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetManagersSumOfPayments(managers, from, to, sites) {
			const url = `/${this.userRole}/stats/get-sum-payments`;
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;
			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data.data;
		},
		async dbGetSiteIncome(idWebsite, from, to) {
			const url = `${this.userRole}/stats/get-graph-income`;

			const optionsList = [
				`filter[site_id]=${idWebsite}`,
				`filter[date_from]=${from}`,
				`filter[date_to]=${to}`
			];
			const options = this.dbGetOptions(optionsList);

			return (await this.$http.get(url + options)).data.data;
		},
		async dbGetRefundsCount(options) {
			return await this.getRefundsStats("count", options);
		},
		async dbGetRefundsSum(options) {
			return await this.getRefundsStats("sum", options);
		},
		async dbGetRefundsRate(options) {
			return await this.getRefundsStats("", options);
		},
		async dbGetRefundsTable(options, excel = false) {
			return await this.getRefundsStats("table", options, excel);
		},
		async getRefundsStats(
			url,
			{ managers, from, to, sites, reasons },
			excel
		) {
			let fullUrl;
			if (url === "count") {
				fullUrl = `/${this.userRole}/stats/get-number-of-returns`;
			} else if (url === "sum") {
				fullUrl = `/${this.userRole}/stats/get-sum-returns`;
			} else if (url === "table") {
				fullUrl = `/${this.userRole}/stats/get-table-order-returns`;
			} else {
				fullUrl = `/${this.userRole}/stats/get-return-rate`;
			}
			let options = "";

			if (excel) {
				options = "?excel=1&";
			}

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;
			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}
			if (sites !== undefined && sites !== null) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}
			if (reasons !== undefined && reasons !== null) {
				reasons.forEach((reason, index) => {
					options += `&filter[return_reason_id][${index}]=${reason}`;
				});
			}
			if (options.length !== 0 && fullUrl.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(fullUrl + options)).data;
		},

		async dbGetSitesStatsGraph(options) {
      const url = `/${this.userRole}/stats/get-graph-income-website`
			return (await this.dbGetSitesStats(url, options)).data;
		},

		async dbGetSitesNumberOfPayments(options) {
      const url = `/${this.userRole}/stats/get-number-of-payments-website`
			return (await this.dbGetSitesStats(url, options)).data;
		},

		async dbGetSitesSumOfPayments(options) {
      const url = `/${this.userRole}/stats/get-sum-payments-website`
			return (await this.dbGetSitesStats(url, options)).data;
		},

		async dbGetSitesStatsTable(options, excel = false) {
      const url = `/${this.userRole}/stats/get-table-income-website`
			return await this.dbGetSitesStats(url, options, excel);
		},

    async dbGetSitesStats(
			url,
			{ from, to, sites },
			excel
    ) {
			let options = "";

			if (excel) {
				options = "?excel=1&";
			}

			if (from !== undefined && from !== null) {
				options += `&filter[date_from]=${from}`;

      }
			if (to !== undefined && to !== null) {
				options += `&filter[date_to]=${to}`;
      }

			if (sites !== undefined && sites !== null) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1) {
				options = "?" + options.substr(1, options.length - 1);
			}

			return (await this.$http.get(url + options)).data;
    },

		async dbGetFailsTable(options, excel = false) {
			return await this.dbGetFailsStats("table", options, excel);
		},

		async dbGetFailsRate(options) {
			return await this.dbGetFailsStats("", options);
		},

		async dbGetFailsSum(options) {
			return await this.dbGetFailsStats("sum", options);
		},

		async dbGetFailsStats(
			url,
			{ managers, from, to, sites, reasons },
			excel
		) {
			let fullUrl;
			if (url === "sum") {
				fullUrl = `/${this.userRole}/stats/get-sum-fails`;
			} else if (url === "table") {
				fullUrl = `/${this.userRole}/stats/get-table-order-fails`;
			} else {
				fullUrl = `/${this.userRole}/stats/get-fails-rate`;
			}
			let options = "";

			if (excel) {
				options = "?excel=1&";
			}

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;
			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}
			if (sites !== undefined && sites !== null) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}
			if (reasons !== undefined && reasons !== null) {
				reasons.forEach((reason, index) => {
					options += `&filter[fail_reason_id][${index}]=${reason}`;
				});
			}
			if (options.length !== 0 && fullUrl.indexOf("?") === -1) {
				options = "?" + options.substr(1, options.length - 1);
			}

			return (await this.$http.get(fullUrl + options)).data;
		},

		async dbGetPenaltiesCount(options) {
			return await this.getPenaltiesStats("count", options);
		},
		async dbGetPenaltiesSum(options) {
			return await this.getPenaltiesStats("sum", options);
		},
		async dbGetPenaltiesRate(options) {
			return await this.getPenaltiesStats("", options);
		},

		async getPenaltiesStats(url, from, to) {
			let fullUrl;
			if (url === "count") {
				fullUrl = `/${this.userRole}/stats/get-number-of-penalties`;
			} else if (url === "sum") {
				fullUrl = `/${this.userRole}/stats/get-sum-penalties`;
			} else {
				fullUrl = `/${this.userRole}/stats/get-penalties-rate`;
			}
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;
			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;
			if (options.length !== 0 && fullUrl.indexOf("?") === -1)
				options = "?" + options.substr(1, options.length - 1);

			return (await this.$http.get(fullUrl + options)).data.data;
		},

		async dbGetAnswersTimeTable({ from, to, managers, sites, replies }) {
			let url = `/${this.userRole}/stats/get-table-replies`;
			let options = "?";

			if (from) {
				options += `&filter[date_from]=${from}`;
			}

			if (to) {
				options += `&filter[date_to]=${to}`;
			}

			if (sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (replies.length) {
				replies.forEach((reply, index) => {
					options += `&filter[type][${index}]=${reply}`;
				});
			}

			if (managers.length) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetAnswersTimeWidget({ from, to, managers, sites, replies }) {
			let url = `/${this.userRole}/stats/get-average-replies-time`;
			let options = "?";

			if (from) {
				options += `&filter[date_from]=${from}`;
			}

			if (to) {
				options += `&filter[date_to]=${to}`;
			}

			if (sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (replies.length) {
				replies.forEach((reply, index) => {
					options += `&filter[type][${index}]=${reply}`;
				});
			}

			if (managers.length) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetAnswersTimeGraph({ from, to, managers, sites, replies }) {
			let url = `/${this.userRole}/stats/get-graph-replies`;
			let options = "?";

			if (from) {
				options += `&filter[date_from]=${from}`;
			}

			if (to) {
				options += `&filter[date_to]=${to}`;
			}

			if (sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (replies.length) {
				replies.forEach((reply, index) => {
					options += `&filter[type][${index}]=${reply}`;
				});
			}

			if (managers.length) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			return (await this.$http.get(url + options)).data.data;
		},

		async dbGetStatsExcelFile(managers, from, to, sites) {
			const url = `/${this.userRole}/stats/get-table-income-manager`;
			let options = "";

			if (from !== undefined && from !== null)
				options += `&filter[date_from]=${from}`;

			if (to !== undefined && to !== null)
				options += `&filter[date_to]=${to}`;

			if (managers !== undefined && managers !== null) {
				managers.forEach((manager, index) => {
					options += `&filter[user_id][${index}]=${manager}`;
				});
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1)
				options = "?excel=1&" + options.substr(1, options.length - 1);

			return (await this.$http.get(url + options)).data;
		},

    async dbGetLidsData(url, { from, to, sites, managers, hideSpam }) {
			let fullUrl = `/${this.userRole}/${url}`
			let options = '';

      if (hideSpam !== undefined && hideSpam !== null) {
        options += `filter[hide_spam]=${hideSpam}`
      }

			if (from) {
				options += `&filter[date_from]=${from}`;
			}

			if (to) {
				options += `&filter[date_to]=${to}`;
			}

			if (sites && sites.length) {
				sites.forEach((site, index) => {
					options += `&filter[website_id][${index}]=${site}`;
				});
			}

			if (managers && managers.length) {
				managers.forEach((user_id, index) => {
					options += `&filter[user_id][${index}]=${user_id}`;
				});
			}

			if (options.length !== 0 && url.indexOf("?") === -1) {
				options = "?" + options
			}

			return (await this.$http.get(fullUrl + options)).data;
    },

		async dbGetLeadsConversionPercent(options) {
			const url = "stats/get-leads-conversion-percent";
      return (await this.dbGetLidsData(url, options)).data;
		},

		async dbGetLeadsTable(options) {
			const url = "stats/get-table-leads";
      return (await this.dbGetLidsData(url, options)).data;
		},

		async dbGetLeadsNumber(options) {
			const url = "stats/get-number-leads";
      return (await this.dbGetLidsData(url, options)).data;
		},

		async dbGetPaidLeadsNumber(options) {
			const url = "stats/get-number-paid-leads";
      return (await this.dbGetLidsData(url, options)).data;
		},
		// ------------------- End Stats

		// ------------------- Logs
		async dbGetManagersLogs({
			sortType,
			limit,
			offset,
			off,
			to,
			managers,
			actions,
			sortKey,
			orderId
		}) {
			let options = "";

			if (sortType) {
				options += `&sort[${sortKey}]=${sortType}`;
			}

			if (limit) {
				options += `&limit=${limit}`;
			}

			if (offset) {
				options += `&offset=${offset}`;
			}

			if (off) {
				options += `&filter[date_from]=${moment(off).format(
					"YYYY-MM-DD"
				)}`;
			}

			if (to) {
				options += `&filter[date_to]=${moment(to).format(
					"YYYY-MM-DD"
				)}`;
			}

			if (orderId) {
				options += `&filter[order_id]=${orderId}`;
			}

			if (managers) {
				managers.forEach((manager, index) => {
					options += `&filter[user_manager_id][${index}]=${manager}`;
				});
			}

			if (actions) {
				actions.forEach((action, index) => {
					options += `&filter[action][${index}]=${action}`;
				});
			}

			const url = `/admin/manager/get-log?${options}`;
			return (await this.$http.get(url)).data;
		},

		async dbGetManagersLogAction() {
			const url = `/admin/manager-log-action`;
			return (await this.$http.get(url)).data;
		},

		async dbGetManagersLogCount({ off, to, managers, actions, orderId }) {
			let options = "";

			if (off) {
				options += `&filter[date_from]=${moment(off).format(
					"YYYY-MM-DD"
				)}`;
			}

			if (to) {
				options += `&filter[date_to]=${moment(to).format(
					"YYYY-MM-DD"
				)}`;
			}

			if (orderId) {
				options += `&filter[order_id]=${orderId}`;
			}

			if (managers) {
				managers.forEach((manager, index) => {
					options += `&filter[user_manager_id][${index}]=${manager}`;
				});
			}

			if (actions) {
				actions.forEach((action, index) => {
					options += `&filter[action][${index}]=${action}`;
				});
			}
			const url = `/admin/manager/get-log-actions-count?${options}`;
			return (await this.$http.get(url)).data.data;
		}
	}
};
